import ConstructionScreen from './components/ConstructionScreen'

export default {
  path: '/demo',
  name: 'Construction',
  component: ConstructionScreen
}



// WEBPACK FOOTER //
// ./src/app/screens/Construction/index.js